<template>
		<div class="bracket-game">
			<div class="correct-winner-1">
				<span class="seed" :class="{ winner: gameData.winner_id == correctWinner1.id }">{{ correctWinner1.seed }}</span>
				<span class="team-name" :class="{ winner: gameData.winner_id == correctWinner1.id }">{{ correctWinner1.name }}</span>
			</div>
			<div class="teams" :class="{ 'game-completed': gameData.winner_id != null }">
				<div class="team team-1">
					<span class="seed" :class="{ incorrect: participant1Incorrect, correct: participant1Correct, winner: gameData.winner_id == participant1.id }">{{ participant1.seed }}</span>
					<span class="team-name" :class="{ incorrect: participant1Incorrect, correct: participant1Correct, winner: gameData.winner_id == participant1.id }">{{ participant1.team.short_name }}</span>
				</div>
				<div class="team team-2">
					<span class="seed" :class="{ incorrect: participant2Incorrect, correct: participant2Correct, winner: gameData.winner_id == participant2.id }">{{ participant2.seed }}</span>
					<span class="team-name" :class="{ incorrect: participant2Incorrect, correct: participant2Correct, winner: gameData.winner_id == participant2.id }">{{ participant2.team.short_name }}</span>
				</div>
			</div>
			<div class="correct-winner-2">
				<span class="seed" :class="{ winner: gameData.winner_id == correctWinner2.id }">{{ correctWinner2.seed }}</span>
				<span class="team-name" :class="{ winner: gameData.winner_id == correctWinner2.id }">{{ correctWinner2.name }}</span>
			</div>
		</div>
</template>

<script>
	export default {
		props: ['gameData', 'previousGame1Data', 'previousGame2Data'],
		computed: {
			participant1() {
				if(this.gameData.previous_game_picks[0].id != null) {
					return this.gameData.previous_game_picks[0]
				} else {
					return this.gameData.participants[0]
				}
			},
			participant2() {
				if(this.gameData.previous_game_picks[1].id != null) {
					return this.gameData.previous_game_picks[1]
				} else {
					return this.gameData.participants[1]
				}
			},
			correctWinner1() {
				var result = {
					id: '',
					seed: '',
					name: '',
				}
				if(this.gameData.previous_game_picks[0].id != null && this.gameData.participants[0].id != null && this.gameData.previous_game_picks[0].id != this.gameData.participants[0].id) {
					result = {
						id: this.gameData.participants[0].id,
						seed: this.gameData.participants[0].seed,
						name: this.gameData.participants[0].team.short_name
					}
				}
				return result
			},
			correctWinner2() {
				var result = {
					id: '',
					seed: '',
					name: '',
				}
				if(this.gameData.previous_game_picks[1].id != null && this.gameData.participants[1].id != null && this.gameData.previous_game_picks[1].id != this.gameData.participants[1].id) {
					result = {
						id: this.gameData.participants[1].id,
						seed: this.gameData.participants[1].seed,
						name: this.gameData.participants[1].team.short_name
					}
				}
				return result
			},
			participant1Incorrect() {
				if(this.correctWinner1.name != '' || (this.gameData.winner_id == null && this.gameData.previous_game_picks[0].eliminated == true)) {
					return true
				} else {
					return false
				}
			},
			participant2Incorrect() {
				if(this.correctWinner2.name != '' || (this.gameData.winner_id == null && this.gameData.previous_game_picks[1].eliminated == true)) {
					return true
				} else {
					return false
				}
			},
			participant1Correct() {
				if(this.previousGame1Data == undefined) {
					return false
				}

				if(this.previousGame1Data.winner_id == this.participant1.id) {
					return true
				} else {
					return false
				}
			},
			participant2Correct() {
				if(this.previousGame2Data == undefined) {
					return false
				}

				if(this.previousGame2Data.winner_id == this.participant2.id) {
					return true
				} else {
					return false
				}
			}
		}
	}
</script>